import { useEffect, useState } from "react";
import "../Styles/AgentDetails.css";
import { useLocation, useNavigate } from "react-router-dom";
import Logo from "../assests/images/default_busi_logo.png";
import { IoChevronBackOutline } from "react-icons/io5";

import { get_agent_reviews } from "../api/serverWrapper";
import LangIcon from "../assests/images/lang-icon.png";
import { FaMapMarkerAlt, FaClock } from "react-icons/fa";

function AgentDetails() {
  const location = useLocation();
  const navigate = useNavigate();

  const {
    partner,
    religionOptions,
    casteOptions,
    communityOptions,
    languages,
    fromMyAgent,
  } = location.state || {};

  console.log(partner);

  const [agentReviews, setAgentReviews] = useState([]);

  useEffect(() => {
    loadAgentReviews();
  }, []);

  const loadAgentReviews = async () => {
    try {
      const response = await get_agent_reviews(partner?.UserId);

      console.log("Agent Reviews", response);

      if (response?.code === 200) {
        setAgentReviews(response?.data || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className=" ">
      <div className="client-setup-header-main">
        <div className="client-setup-header-left">
          <IoChevronBackOutline
            className="client-setup-back-icon"
            // onClick={() =>
            //   navigate("/browseagents", {
            //     replace: true,
            //   })
            // }
            onClick={() => navigate(-1)}
          />

          <img
            src={require("../assests/images/nav_bar_logo.png")}
            alt="Wedluk Logo"
            className="client-setup-logo"
          />
        </div>

        <div className="client-setup-header-right">
          <span> Registered partners </span>
        </div>
      </div>

      {/* MAIN CARD */}

      <div className="review-main-card mx-4 my-4">
        {/* PROFILE */}

        <div className="review-profile-card">
          <div className="d-flex align-items-center justify-content-center gap-3">
            <img
              src={partner?.BusinessLogo || Logo}
              alt=""
              className="review-logo-circle"
            />

            <h1>{partner?.BusinessName}</h1>
          </div>

          <p className="review-tagline">For your forever</p>

          <div className="review-stars">★ ★ ★ ★ ☆</div>

          <div className="review-top-info">
            <div> <FaMapMarkerAlt />  {partner?.User?.Address?.CityId},{" "}
              {partner?.User?.Address?.CountryId}</div>

            <div>🕒 {partner?.BusinessExperience || 0} years</div>

            <div>
              <img className="icons-for-partner me-2"   src={LangIcon} alt="" />
              {partner?.LanguagesServe?.includes("all")
                ? " All Languages"
                : languages
                    ?.filter((item) =>
                      partner?.LanguagesServe?.includes(item.LangId),
                    )
                    ?.slice(0, 2)
                    ?.map((item) => item.LangDesc)
                    ?.join(", ")}
            </div>
          </div>
        </div>

        {/* ABOUT */}

        <div className="review-about-section">
          <h3>About</h3>

          <p>{partner?.BusinessDescription}</p>
        </div>

        {/* IMAGES */}

        <div className="agent-gallery-images">
          {partner?.PromotionalImages?.length > 0 ? (
            partner?.PromotionalImages?.map((img, index) => (
              <img key={index} src={img} alt="" />
            ))
          ) : (
            <>
              <img
                src="https://images.unsplash.com/photo-1511285560929-80b456fea0bc?q=80&w=1200&auto=format&fit=crop"
                alt=""
              />

              <img
                src="https://images.unsplash.com/photo-1520854221256-17451cc331bf?q=80&w=1200&auto=format&fit=crop"
                alt=""
              />

              <img
                src="https://images.unsplash.com/photo-1519741497674-611481863552?q=80&w=1200&auto=format&fit=crop"
                alt=""
              />
            </>
          )}
        </div>

        {/* DETAILS */}

        <div className="review-detail-grid">
          {/* LEFT */}
          <div className="review-detail-card">
            <h3>Service Details</h3>

            {/* RELIGIONS */}

            <div className="review-section">
              <p className="review-label">Religions</p>

              <div className="review-pill-row">
                {partner?.ReligionsServe?.includes("all") ? (
                  <div className="review-pill">All Religions</div>
                ) : (
                  religionOptions
                    ?.filter((o) => partner?.ReligionsServe?.includes(o.value))
                    ?.map((item, index) => (
                      <div className="review-pill" key={index}>
                        {item.label}
                      </div>
                    ))
                )}
              </div>
            </div>

            {/* CASTE */}

            <div className="review-section">
              <p className="review-label">Castes</p>

              <div className="review-pill-row">
                {partner?.CastesServe?.includes("all") ? (
                  <div className="review-pill">All Castes</div>
                ) : (
                  casteOptions
                    ?.filter((o) => partner?.CastesServe?.includes(o.value))
                    ?.map((item, index) => (
                      <div className="review-pill" key={index}>
                        {item.label}
                      </div>
                    ))
                )}
              </div>
            </div>

            {/* COMMUNITIES */}

            <div className="review-section">
              <p className="review-label">Communities</p>

              <div className="review-pill-row">
                {partner?.CommunitesServe?.includes("all") ? (
                  <div className="review-pill">All Communities</div>
                ) : (
                  communityOptions
                    ?.filter((o) => partner?.CommunitesServe?.includes(o.value))
                    ?.map((item, index) => (
                      <div className="review-pill" key={index}>
                        {item.label}
                      </div>
                    ))
                )}
              </div>
            </div>

            {/* LANGUAGES */}

            <div className="review-section">
              <p className="review-label">Language communities serve</p>

              <div className="review-pill-row">
                {partner?.LanguagesServe?.includes("all") ? (
                  <div className="review-pill">All Languages</div>
                ) : (
                  languages
                    ?.filter((o) => partner?.LanguagesServe?.includes(o.LangId))
                    ?.map((item, index) => (
                      <div className="review-pill" key={index}>
                        {item.LangDesc}
                      </div>
                    ))
                )}
              </div>
            </div>
          </div>

          {/* RIGHT */}

          <div className="review-detail-card">
            <h3>Agency Details</h3>

            <div className="review-price-section">
              <p className="review-label">Contact Number</p>

              <h4>{partner?.User?.PhoneNumber}</h4>
            </div>

            <div className="review-price-section">
              <p className="review-label">Email Address</p>

              <h4>{partner?.User?.EMail}</h4>
            </div>

            <div className="review-price-section">
              <p className="review-label">Business Address</p>

              <h4>{partner?.BusinessAddress}</h4>
            </div>

            <p className="review-note">
              Trusted matrimonial agency helping families and individuals find
              meaningful lifelong connections.
            </p>
          </div>
        </div>

        {/* CONTACT */}

        <div className="review-contact-section">
          <h3>Contact agency</h3>

          <div className="review-contact-grid">
            <div>
              <img
                className="review-contact-icon"
                src={require("../assests/images/contect-info.png")}
              />

              {partner?.User?.PhoneNumber}
            </div>

            <div>
              <img
                className="review-contact-icon"
                src={require("../assests/images/email-icon.png")}
              />

              {partner?.User?.EMail}
            </div>
          </div>

          <div className="review-contact-address">
            <img
              className="review-contact-icon"
              src={require("../assests/images/address-icon.png")}
            />

            <div className="review-address">{partner?.BusinessAddress}</div>
          </div>
        </div>

        <div className="client-review-main">
          <div className="client-review-header">
            <h3>Client reviews</h3>
          </div>

          <div className="client-review-grid">
            {agentReviews?.length > 0 ? (
              agentReviews?.map((item, index) => (
                <div className="client-review-card" key={index}>
                  <div className="client-review-top">
                    <img
                      src={
                        item?.Profile?.User?.ProfilePhotoUrl ||
                        "https://randomuser.me/api/portraits/women/44.jpg"
                      }
                      alt=""
                    />

                    <div>
                      <h4>{item?.Profile?.User?.FirstName}</h4>

                      <div className="client-review-stars">
                        {"★".repeat(item?.Rating || 0)}

                        {"☆".repeat(5 - (item?.Rating || 0))}
                      </div>
                    </div>
                  </div>

                  <p>{item?.ReviewComment}</p>
                </div>
              ))
            ) : (
              <div className="text-center py-4">No Reviews Found</div>
            )}
          </div>

          <div className="client-review-footer">
            <button
              onClick={() =>
                navigate("/all-agent-reviews", {
                  state: {
                    agentReviews,
                    partner,
                  },
                })
              }
            >
              View all ❯
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AgentDetails;
